<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    no-close-on-backdrop
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <label>Código</label>
      <b-form-input
        type="text"
        placeholder="Código"
        v-model="form.cd"
        name="cd"
      >
      </b-form-input>
      <b-form-feedback
        v-text="form.errors.get('cd')"
        v-if="form.errors.has('cd')"
      ></b-form-feedback>

      <label>Descrição</label>
      <b-form-input
        type="text"
        placeholder="Descrição"
        v-model="form.descr"
        name="descr"
      >
      </b-form-input>
      <b-form-feedback
        v-text="form.errors.get('descr')"
        v-if="form.errors.has('descr')"
      ></b-form-feedback>

      <label>Finalizou entrega?</label>
      <b-form-radio-group
        v-model="form.finalizacao_entrega"
        :options="this.$parent.optionsLivFinalizacao"
        value-field="value"
        text-field="label"
        name="finalizacao_entrega"
        plain
        inline
      ></b-form-radio-group>
      <b-form-feedback
        v-text="form.errors.get('finalizacao_entrega')"
        v-if="form.errors.has('finalizacao_entrega')"
      ></b-form-feedback>

      <label>Reentrega</label>
      <b-form-radio-group
        v-model="form.reentrega"
        :options="this.$parent.optionsReentrega"
        value-field="value"
        text-field="label"
        name="reentrega"
        plain
        inline
      ></b-form-radio-group>
      <b-form-feedback
        v-text="form.errors.get('reentrega')"
        v-if="form.errors.has('reentrega')"
      ></b-form-feedback>

      <label>Status</label>
      <b-form-radio-group
        v-model="form.status"
        :options="this.$parent.optionsLivStatus"
        value-field="value"
        text-field="label"
        name="status"
        plain
        inline
      ></b-form-radio-group>
      <b-form-feedback
        v-text="form.errors.get('status')"
        v-if="form.errors.has('status')"
      ></b-form-feedback>

      <label>Tipo Operação</label>
      <multiselect
        v-model="tpOperacaoSelected"
        :options="this.$parent.optionsTpOperacao"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('tp_operacao')"
        v-if="form.errors.has('tp_operacao')"
      ></b-form-feedback>

      <label>Tipo Isend</label>
      <multiselect
        v-model="isendSelected"
        :options="this.$parent.optionsTpIsend"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('tp_isend')"
        v-if="form.errors.has('tp_isend')"
      ></b-form-feedback>

      <label>Portal Transp?</label>
      <b-form-radio-group
        v-model="form.portal_transp"
        :options="this.$parent.optionsPortalTransp"
        value-field="value"
        text-field="label"
        name="portal_transp"
        plain
        inline
      ></b-form-radio-group>
      <b-form-feedback
        v-text="form.errors.get('portal_transp')"
        v-if="form.errors.has('portal_transp')"
      ></b-form-feedback>

      <label>Usa Conferência?</label>
      <b-form-radio-group
        v-model="form.usa_conferencia"
        :options="this.$parent.optionsUsaConferencia"
        value-field="value"
        text-field="label"
        name="usa_conferencia"
        plain
        inline
      ></b-form-radio-group>
      <b-form-feedback
        v-text="form.errors.get('usa_conferencia')"
        v-if="form.errors.has('usa_conferencia')"
      ></b-form-feedback>

      <label>Exige Tratativa?</label>
      <b-form-radio-group
        v-model="form.exige_tratativa"
        :options="this.$parent.optionsExigeTratativa"
        value-field="value"
        text-field="label"
        name="exige_tratativa"
        plain
        inline
      ></b-form-radio-group>
      <b-form-feedback
        v-text="form.errors.get('exige_tratativa')"
        v-if="form.errors.has('exige_tratativa')"
      ></b-form-feedback>

      <label>Tipos de Processos</label>
      <multiselect
        v-model="tiposProcessosSelected"
        :options="this.$parent.optionsTpProcessos"
        track-by="value"
        label="label"
        :multiple="true"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('tp_processo')"
        v-if="form.errors.has('tp_processo')"
      ></b-form-feedback>

      <label>Cancela Cte na NSTech?</label>
      <b-form-radio-group
          v-model="form.cancela_cte_nstech"
          :options="this.$parent.optionsCancelaCteNstech"
          value-field="value"
          text-field="label"
          name="cancela_cte_nstech"
          plain
          inline
      ></b-form-radio-group>
      <b-form-feedback
          v-text="form.errors.get('cancela_cte_nstech')"
          v-if="form.errors.has('cancela_cte_nstech')"
      ></b-form-feedback>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  components: {},
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: ""
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      tpOperacaoSelected: null,
      isendSelected: null,
      tiposProcessosSelected: [],
      form: new Form({
        cd: "",
        descr: "",
        param_id: "",
        finalizacao_entrega: 2,
        tp_operacao: "",
        portal_transp: 2,
        tp_isend: "",
        status: 1,
        reentrega: 2,
        usa_conferencia: 2,
        exige_tratativa: 2,
        tp_processo: [],
        cancela_cte_nstech: 2,
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  watch: {
    tpOperacaoSelected(obj) {
      this.form.tp_operacao = obj.value;
    },
    isendSelected(obj) {
      this.form.tp_isend = obj.value;
    },
    tiposProcessosSelected(obj) {
      this.form.tp_processo = obj.map(item => item.value);
    }
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao === "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.param_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.form.finalizacao_entrega = 2;
      this.form.reentrega = 2;
      this.form.portal_transp = 2;
      this.form.usa_conferencia = 2;
      this.form.exige_tratativa = 2;
      this.form.status = 1;
      this.form.cancela_cte_nstech = 2;
      this.tpOperacaoSelected = null;
      this.isendSelected = null;
      this.tiposProcessosSelected = [];
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.form.status = data.status.valor;
      this.form.finalizacao_entrega = data.finalizacaoEntrega.valor;
      this.form.reentrega = data.reentrega ? data.reentrega.valor : 2;
      this.form.tp_operacao = data.tpOperacao.valor;
      this.form.portal_transp = data.portalTransp.valor;
      this.form.tp_isend = data.tpIsend.valor;
      this.form.usa_conferencia = data.usaConferencia.valor;
      this.form.exige_tratativa = data.exigeTratativa.valor;
      this.form.tp_processo = data.paramOcorrenciaProcesso.filter(tp => tp.status.valor == 1).map(tp => tp.valor);
      this.tpOperacaoSelected = { value: data.tpOperacao.valor, label: data.tpOperacao.descr };
      this.isendSelected = { value: data.tpIsend.valor, label: data.tpIsend.descr };
      this.tiposProcessosSelected = data.paramOcorrenciaProcesso.filter(tp => tp.status.valor == 1).map(tp => ({ label: tp.tpProcesso.descr, value: tp.tpProcesso.valor }));
      this.form.param_id = id;
      this.form.cancela_cte_nstech = data.cancelaCteNstech.valor;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .put("/api/" + this.rota + "/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch("/api/" + this.rota + "/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/" + this.rota + "/status")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
